module.exports = __webpack_public_path__ + "static/media/prev.b565995f.svg";